import React from "react";
import { BTCCalculator } from "./ifInvestCalculator";
import { ROICalculator } from "./roiCalculator";
import { RRRCalculator } from "./rrrCalculate";

export const CalculatorMain = () => {
  return (
    <div className="calculatorMain">
      <div className="container">
        <BTCCalculator />
        <ROICalculator />
        <RRRCalculator />
      </div>
    </div>
  );
};
